const nomes = [
    '',
    'mil',
    'milhões',
    'bilhões',
    'trilhões',
    'quatrilhões',
    'quintilhões',
    'sextilhões',
    'septilhões',
    'octilhões',
    'nonilhões',
    'decilhões',
    'undecilhões',
    'duodecilhões',
    'tredecilhões'
];

export default nomes;



// WEBPACK FOOTER //
// ./src/app/shared/helpers/numberToWord/lib/nomesExtenso/casas.ts